<template>
  <a-modal v-model="visible" width="1200px" :confirmLoading="confirmLoading" :centered="true" title="编辑课程资源包" @cancel="handleCancel" @ok="handleOk">
    <PackResource ref="PackResourceModalRef" :textTit="textTit" :edit="true" :record="options" :courseType="{ 测评: 1, 训练: 2, 活动: 3 }[options.textTit]" :courseList="courseList" />
  </a-modal>
</template>
<script>
import PackResource from '../components/packResource.vue'
export default {
  name: 'EditPackResourceModal',
  components: { PackResource },
  props: {
    textTit: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      options: {},
      courseList: [],
    }
  },
  methods: {
    showModal(options) {
      return new Promise((resolve, reject) => {
        this.options = options
        this.visible = true
        this._resolve = resolve
        this._reject = reject
        this.getPageList()
        this.$nextTick(() => {
          const PackResourceRef = this.$refs['PackResourceModalRef']
          PackResourceRef.resetFields()
          PackResourceRef.setForm(options)
        })
      })
    },
    async handleOk() {
      const PackResourceRef = this.$refs['PackResourceModalRef']
      const packForm = await PackResourceRef.getForm()
      const params = {
        superiorOrganizationId: this.options.superiorOrganizationId,
        organizationId: this.options.organizationId,
        editOrganizationCourseResourcePackageParams: [
          {
            id: this.options.id,
            superiorCourseResourcePackageId: this.options.superiorCourseResourcePackageId,
            name: packForm.name,
            maxCount: packForm.maxCount || 0,
            isLimitCount: !packForm.isLimitCount,
            courseConfigs: packForm.courseConfigs,
            organizationId: this.options.organizationId,
            superiorOrganizationId: this.options.superiorOrganizationId,
          },
        ],
      }
      this.confirmLoading = true
      this.$http.CourseService.editCoursePackage(params, { message: false })
        .then(() => {
          this.$message.success('操作成功')
          this._resolve()
          this.visible = false
        })
        .catch((err) => {
          if (err.errors?.length) {
            const errCourse = PackResourceRef.gradeTableRelevant.tableDataSource
              .filter((v) => err.errors.includes(v._courseId))
              .map((v) => v.courseName + '-' + v.period)
              .join('，')
            PackResourceRef.setErrorId(err.errors)
            this.$message.error(err.message + '：' + errCourse)
          } else {
            this.$message.error(err.message)
          }
          return err
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    handleCancel() {
      this._reject()
      this.visible = false
    },
    getPageList() {
      const params = {
        pageIndex: 1,
        pageSize: 9999,
        OrganizationCourseResourcePackageId: this.options.id,
      }
      this.$http.CourseService.getCourseListByPackage(params).then((res) => {
        const { data } = res
        this.courseList = data.items.map((v) => {
          v.courseName = v.courseResourceName
          v.courseChildCount = v.childCourseCount
          v._courseId = v.courseResourceId
          v.selectReportIds = v.courseReportIds
          v.reportList =  []
          return v
        })
        console.log(this.courseList);
      })
    },
  },
}
</script>
<style lang="less" scoped></style>
